export default __webpack_public_path__ + "static/Group 183-489009e754c9e8883e3f6305cf5edb0f.png";